import { defineMessages } from 'react-intl';

export const chatEmptyConversationMessages = defineMessages({
  emptyConversation: {
    defaultMessage: 'This conversation is empty', id: 't+JzhI7lZs',
    description:
      'Primary line shown when an existing Evidence chat has no messages yet',
  },
  sendMessageToStart: {
    defaultMessage: 'Send a message to get started', id: 'bIOrpkW5sH',
    description:
      'Secondary hint below the empty-conversation message encouraging the user to type in the chat',
  },
});
